import { render, staticRenderFns } from "./tambahinformasi.vue?vue&type=template&id=52589063&"
import script from "./tambahinformasi.vue?vue&type=script&lang=js&"
export * from "./tambahinformasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports